import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './LocusRobotics.frontend.types'

@Injectable({ providedIn: 'root' })
export class LocusRobotics_inventoryCount_requestService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { JobId: string, ItemNo: string, Location: string }): Promise<{ InventoryCountResponse?: any }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.JobId)) {
      missingRequiredInParams.push('\'JobId\'');
    }
    if (isNil(inParams.ItemNo)) {
      missingRequiredInParams.push('\'ItemNo\'');
    }
    if (isNil(inParams.Location)) {
      missingRequiredInParams.push('\'Location\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

